import LongpipeBackgroundProcessor, { BackgroundOptions } from './LongpipeBackgroundProcessor'

export * from './transformers/types'
export { default as VideoTransformer } from './transformers/VideoTransformer'
export { default as ProcessorWrapper } from './ProcessorWrapper'
export { LongpipeBackgroundProcessor, type BackgroundOptions }

/** Создаёт процессор размытия камеры.
 * @param blurRadius — сигма размытия фона.
 */
export function BackgroundBlur(blurRadius = 10) {
  return BackgroundProcessor({ blurRadius }, 'background-blur')
}

/** Создаёт процессор подмены фона изображением.
 * @param imagePath — адрес изображения фона.
 */
export function VirtualBackground(imagePath: string) {
  return BackgroundProcessor({ imagePath }, 'virtual-background')
}

/** Создаёт адаптер Longpipe для публикации и превью LiveKit.
 * @param options — выбранные параметры фона.
 * @param name — тип эффекта.
 */
export function BackgroundProcessor(options: BackgroundOptions, name = 'background-processor') {
  if (!LongpipeBackgroundProcessor.isSupported) {
    throw new Error('Обработка фона не поддерживается в этом браузере')
  }

  return new LongpipeBackgroundProcessor(options, name)
}
